import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { QueryProvider } from "@/providers/QueryProvider";
import App from "@/App";
import "@/styles/index.css";

// Global error handler for unhandled errors
window.addEventListener("error", event => {
  console.error("Global error:", event.error);
  // Ensure body has dark background in case of critical errors
  document.body.classList.add("error-fallback");
});

// Global handler for unhandled promise rejections
window.addEventListener("unhandledrejection", event => {
  console.error("Unhandled promise rejection:", event.reason);
  // Ensure body has dark background in case of critical errors
  document.body.classList.add("error-fallback");
});

const root = ReactDOM.createRoot(document.getElementById("root")!);

// Clear the loading fallback and render the app
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <QueryProvider>
        <App />
      </QueryProvider>
    </HelmetProvider>
  </React.StrictMode>
);

// Remove the loading fallback once React has mounted
setTimeout(() => {
  const loadingFallback = document.querySelector(".loading-fallback");
  if (loadingFallback) {
    loadingFallback.remove();
  }
}, 100);
